import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-pause-subscription-dialog',
  templateUrl: './pause-subscription-dialog.component.html',
  styleUrls: ['./pause-subscription-dialog.component.scss']
})
export class PauseRecurringInvoiceDialogComponent implements OnInit {

  resumeDate: Date = new Date();
  minDate: string = moment(new Date()).format('YYYY-MM-DD');

  constructor(private modalRef: NgbActiveModal,) { }

  ngOnInit() {

  }

  ok(){
    this.modalRef.close(this.resumeDate);
  }

  forceMinDate(e) {
    if (e.target.value) {
      if (new Date(e.target.value) < new Date(e.target.min)) {
        e.target.value = e.target.min;
      }
    } else {
      e.target.value = e.target.min;
    }
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

}
